import { createElement } from "react";
import { Clock, CloseCircle } from "iconsax-react";
import CheckIcon from "@/shared/assets/icons/CheckIcon";
import type { BadgeColor } from "@/shared/ui";

interface PipelineBadge {
  color: BadgeColor;
  text: string;
  icon: React.ReactNode;
}

const SIGNED_STATUSES = new Set(["signed", "approved"]);
const PENDING_STATUSES = new Set(["pending_signing", "signing_pending", "pending_review"]);

function makeIcon(color: BadgeColor): React.ReactNode {
  const props = { size: 12, color: "currentColor" as const };
  if (color === "positive") return createElement(CheckIcon);
  if (color === "negative") return createElement(CloseCircle, { ...props, variant: "Bold" });
  return createElement(Clock, props);
}

export function getActPipelineBadge(
  status: string,
  isPaymentApproved: boolean,
  isPaid: boolean,
  t: (key: string) => string,
): PipelineBadge {
  if (isPaid) {
    return { color: "positive", text: t("calculations.pipeline.paid"), icon: makeIcon("positive") };
  }

  if (isPaymentApproved) {
    return { color: "notice", text: t("calculations.pipeline.approved"), icon: makeIcon("notice") };
  }

  if (SIGNED_STATUSES.has(status)) {
    return { color: "notice", text: t("calculations.pipeline.signed"), icon: makeIcon("notice") };
  }

  if (PENDING_STATUSES.has(status)) {
    return { color: "notice", text: t("calculations.status.pendingSigning"), icon: makeIcon("notice") };
  }

  if (status === "rejected") {
    return { color: "negative", text: t("calculations.status.rejected"), icon: makeIcon("negative") };
  }

  if (status === "draft") {
    return { color: "gray", text: t("calculations.status.draft"), icon: makeIcon("gray") };
  }

  return { color: "gray", text: t("calculations.status.unknown"), icon: makeIcon("gray") };
}
